<div class="portfolio-assumptions">
  <klt-company-compare
    (onSelect)="onSelectScenarios($event)"
    (buttonClick)="openDialog()"
  ></klt-company-compare>
  <klt-company-table [updatedData]="tableData"></klt-company-table>
</div>
